import { SET_PURCHASES, SET_PURCHASES_LOADING, SET_PURCHASES_ERROR } from "../../actions/purchaseAction";

var initialState = {
  datas: [],
  loading: false,
  error: null,
};

const purchaseReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_PURCHASES:
      return {
        ...state,
        datas: action.data,
        error: null,
      };

    case SET_PURCHASES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_PURCHASES_LOADING:
      return {
        ...state,
        loading: action.status,
        ...(action.status ? { error: null } : {}),
      };
    default:
      return state;
  }
};

export default purchaseReducer;
